import { render, staticRenderFns } from "./RegistryImport.vue?vue&type=template&id=233c4475&scoped=true&"
import script from "./RegistryImport.vue?vue&type=script&lang=js&"
export * from "./RegistryImport.vue?vue&type=script&lang=js&"
import style0 from "./RegistryImport.vue?vue&type=style&index=0&id=233c4475&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233c4475",
  null
  
)

export default component.exports